// 退款中心-手动审核退款

import {get, post, postJson, deleteApi} from '../axios'

const RESOURCE_BASE_PATH = '/manualAuditRefund/'

// 查询退款订单列表
export const getManualAuditRefund = p => get(`${RESOURCE_BASE_PATH}`, p);

// 批量审核退款订单
export const auditBatch = p => postJson(`${RESOURCE_BASE_PATH}auditBatch`, p);

// 查询待审核订单总数
export const count = p => get(`${RESOURCE_BASE_PATH}/count`, p);

// 根据id查询退款单和订单信息
export const getOrderDetail = id => get(`${RESOURCE_BASE_PATH}${id}`);

// 查询短信记录
export const getSmsRecord = p => get(`${RESOURCE_BASE_PATH}sms/record`, p);